import { render, staticRenderFns } from "./ModalSyncWithForm.vue?vue&type=template&id=516212dc&scoped=true&"
import script from "./ModalSyncWithForm.vue?vue&type=script&lang=js&"
export * from "./ModalSyncWithForm.vue?vue&type=script&lang=js&"
import style0 from "./ModalSyncWithForm.vue?vue&type=style&index=0&id=516212dc&prod&lang=scss&module=true&"
import style1 from "./ModalSyncWithForm.vue?vue&type=style&index=1&id=516212dc&prod&lang=scss&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "516212dc",
  null
  
)

export default component.exports